module.exports = __webpack_public_path__ + "static/media/mediterranean.728595e3.jpg";